import { memo, useCallback, useRef, useState } from 'react';
import { Tooltip } from 'antd';
import { ActionMapWrapper } from '../../Map/styled';
import { MapWrapper } from './styled';
import GoogleMap, { Type_RefFuncGoogleMap } from './Map.GoogleMap';

const SIZE_BOX = {
  normal: { width: 220, height: 160 },
  scale: { width: 500, height: 390 },
};

const Map = memo(() => {
  const googleMapRef = useRef<Type_RefFuncGoogleMap>(null!);

  const isActionAreaOverRef = useRef(false);
  const [sizeBox, setSizeBox] = useState(SIZE_BOX.normal);

  const onCenterToMarkerActive = useCallback(() => {
    googleMapRef.current?.onPanToMarker();
  }, []);

  return (
    <MapWrapper
      id="themeMap"
      onMouseOver={() => setSizeBox(SIZE_BOX.scale)}
      onMouseLeave={() => {
        setSizeBox(SIZE_BOX.normal);
        setTimeout(() => {
          onCenterToMarkerActive();
        }, 200);
      }}
      style={{ width: `${sizeBox.width}px`, height: `${sizeBox.height}px` }}
    >
      <ActionMapWrapper
        style={{
          zIndex: sizeBox.width === SIZE_BOX.scale.width ? 1 : -1,
          opacity: sizeBox.width === SIZE_BOX.scale.width ? 1 : 0,
        }}
        onMouseOver={e => {
          e.stopPropagation();
          isActionAreaOverRef.current = true;
        }}
        onMouseLeave={e => {
          e.stopPropagation();
          isActionAreaOverRef.current = false;
        }}
      >
        <div className="--left" />
        <div className="--right">
          <Tooltip title="Point To Marker Active" placement="top">
            <div className="action--item" onClick={onCenterToMarkerActive}>
              <i aria-hidden className="far fa-crosshairs" />
            </div>
          </Tooltip>
          {/* <Tooltip title="Close" placement="top">
            <div className="action--item" onClick={onCloseMap}>
              <i aria-hidden className="far fa-times" />
            </div>
          </Tooltip> */}
        </div>
      </ActionMapWrapper>

      <GoogleMap ref={googleMapRef} />
    </MapWrapper>
  );
});

export default Map;
